import React, { useEffect, useState } from 'react';
import { useSidebar } from '../contexts/SidebarContext';
import { useContent } from '../contexts/ContentContext';
import { fetchWorks, Work } from '../services/work';
import Modal from './Modal';
import GuideHelpButton from './GuideHelpButton';

const WorksSidebar: React.FC<{ selectedPlatform?: string | null }> = ({ selectedPlatform = null }) => {
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const { content, language, t } = useContent();
    const [works, setWorks] = useState<Work[]>([]);
    const [failed, setFailed] = useState(false);
    const [attempt, setAttempt] = useState(0);
    const [mobile, setMobile] = useState(window.innerWidth < 768);
    const kind = new URLSearchParams(window.location.search).get('kind');
    const platform = selectedPlatform?.toLowerCase();
    useEffect(() => {
        let active = true; setFailed(false);
        fetchWorks().then(value => { if (active) setWorks(value); }).catch(() => { if (active) setFailed(true); });
        return () => { active = false; };
    }, [attempt]);
    useEffect(() => {
        const resize = () => setMobile(window.innerWidth < 768);
        window.addEventListener('resize', resize);
        return () => { window.removeEventListener('resize', resize); };
    }, []);
    const filterLink = (key: string, value: string) => {
        const params = new URLSearchParams({ page: 'gallery', tab: 'works' });
        if (kind) params.set('kind', kind); if (platform) params.set('platform', platform);
        if (value) params.set(key, value); else params.delete(key);
        return '/?' + params;
    };
    const platformLabel = (key: string) => content.ui[language].work.platform[key as keyof typeof content.ui.jp.work.platform] || key;
    const panel = <div className="p-4 space-y-5">
        <a className="block py-2 underline" href="/?page=gallery&tab=works">{t('workPage.all')} ({works.length})</a>
        {failed ? <div role="alert"><p>{t('workPage.error')}</p><button className="lab-button" onClick={() => setAttempt(value => value + 1)}>{t('common.retry')}</button></div> : <>
        <h2 className="font-bold">{t('workPage.kind')}</h2>
        <ul>{Array.from(new Set(works.map(work => work.kind))).map(value => <li key={value}><a className="block py-2 underline" href={filterLink('kind', value)} aria-current={value === kind ? 'page' : undefined}>{t(`work.kind.${value}`)} ({works.filter(work => work.kind === value && (!platform || work.platform === platform)).length})</a></li>)}</ul>
        <details open={!!platform || undefined}><summary className="cursor-pointer font-bold py-2">{t('workPage.platform')}</summary><ul>
            <li><a className="block py-2 underline" href={filterLink('platform', '')}>{t('workPage.all')}</a></li>
            {Array.from(new Set(works.map(work => work.platform))).sort().map(value => <li key={value}><a className="block py-2 underline" href={filterLink('platform', value)} aria-current={value === platform ? 'page' : undefined}>{platformLabel(value)} ({works.filter(work => work.platform === value && (!kind || work.kind === kind)).length})</a></li>)}
        </ul></details>
        </>}
        <GuideHelpButton section="tools" />
    </div>;
    return <>
        {mobile ? <Modal helpSection="work-sidebar" isOpen={isSidebarOpen} onClose={toggleSidebar} title={t('workPage.title')} panelClassName="max-w-md"><aside>{panel}</aside></Modal> : isSidebarOpen && <aside className="lab-page fixed left-0 bottom-0 w-64 overflow-y-auto border-r z-20">{panel}</aside>}
    </>;
};
export default WorksSidebar;
